import script from "./ThemeSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./ThemeSelector.vue?vue&type=script&setup=true&lang=ts"

import "./ThemeSelector.vue?vue&type=style&index=0&id=782b4442&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-782b4442"]])

export default __exports__